
//jQuery
import jQuery from 'jquery'

//Bootstrap
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/modal'


const $ = jQuery;


var win = $(window),
    nav = $('header'),

    pos = nav.offset().top,
    sticky = function(){ 
      win.scrollTop() > pos ?
        nav.addClass('sticky')
      : nav.removeClass('sticky')
    }

win.scroll(sticky)

$(document).ready(function() {
    $('.dropdown-toggle').on('click', function(e) {
      e.preventDefault();
      var dropdownMenu = $(this).next('.dropdown-menu');
      dropdownMenu.toggle();
    });
  
    // Close dropdown menu if clicked outside
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.dropdown').length) {
        $('.dropdown-menu').hide();
      }
    });
  });
  
  